import { createAction, props } from '@ngrx/store';
import { QueryParamsModel } from 'src/app/core/_base/crud';
import { ContactModel } from 'src/app/core/lists';

export const loadContacts = createAction(
  '[Contacts] Load Contacts',
  props<{ query: QueryParamsModel }>(),
);

export const loadContactsSuccess = createAction(
  '[Contacts] Load Contacts Success',
  props<{ contacts: ContactModel[]; totalCount: number }>(),
);
export const setSelectedCellPhone = createAction(
  '[Contacts] Set Selected Cell Phone',
  props<{ cellPhone: string }>(),
);

export const loadContactsFailure = createAction('[Contacts] Load Contacts Failure');

export const resetContactsListState = createAction(
  '[Contacts List] Reset Contacts List State',
  props<{ saveFilter: boolean; filter: { [key: string]: any } }>(),
);
export const toggleContactsListPageLoading = createAction(
  '[Contacts List] Toggle Contacts List Page Loading',
  props<{ pageLoading: boolean }>(),
);

export const updateContact = createAction(
  '[Contacts] Update Contact',
  props<{ id: number; changes: Partial<ContactModel> }>(),
);

export const updateContactSuccess = createAction(
  '[Contacts] Update Contact Success',
  props<{ contact: ContactModel }>(),
);

export const updateContactFailure = createAction(
  '[Contacts] Update Contact Failure',
  props<{ error: any }>(),
);
export const resetSelectedCellPhone = createAction('[Contacts] Reset Selected Cell Phone');
